const PDF: string = 'PDF';
const CSV: string = 'CSV';

export {
    PDF,
    CSV
}